@if (!tableContext.static() && tableContext.controls()) {
  <div>
    <div class="controls">
      <ng-content></ng-content>
      @if (canSelect() && selectOptions()?.actionButton) {
        <ng-container
          *ngTemplateOutlet="
            selectOptions()?.actionButton || null;
            context: ctx
          "
        ></ng-container>
      }
      <button
        buttonTheme="primary"
        buttonType="square"
        [disabled]="
          !tableContext.hasActiveFilters() && !tableContext.isTableSorted()
        "
        (click)="handleResetFilters()"
      >
        <ng-icon name="undo" size="18"></ng-icon>
      </button>
      <button
        [buttonTheme]="
          tableContext.viewType() === 'table' ? 'primary' : 'light'
        "
        buttonType="square"
        (click)="tableContext.changeTableView('table')"
        title="Table View"
      >
        <ng-icon name="ViewColumns3" size="18"></ng-icon>
      </button>

      @if (tableContext.hasChartView()) {
        <button
          [buttonTheme]="
            tableContext.viewType() === 'chart' ? 'primary' : 'light'
          "
          buttonType="square"
          (click)="tableContext.changeTableView('chart')"
          title="Chart View"
        >
          <ng-icon name="GraphUp" size="18"></ng-icon>
        </button>
      }

      <div class="search">
        <app-input
          name="search"
          iconName="search"
          [placeholder]="dictionaryService.get('Search')"
          size="sm"
          [initialValue]="tableContext.searchQuery()"
          (onChange)="debounceSearch($event)"
          [disabled]="tableContext.viewType() === 'chart'"
        ></app-input>
      </div>
      @if (tableContext.canExport()) {
        <app-export-button
          (export)="exportData()"
          [exportLoading]="exportLoading()"
          size="sm"
        />
      }
    </div>
  </div>
}
@if (!tableContext.static()) {
  <div class="table-header">
    <div class="divider"></div>
    <app-table-filters #filtersComponent />
  </div>
}
